import { Component, OnInit } from '@angular/core';
import { App } from 'src/app/models/app';
import { ApplicationHubService } from 'src/app/services/application-hub.service';

@Component({
  selector: 'app-app-list',
  templateUrl: './app-list.component.html',
  styleUrls: ['./app-list.component.scss']
})
export class AppListComponent implements OnInit {

  Data: App[] = [];

  Loading = false;

  constructor(private service: ApplicationHubService) {
   }

  ngOnInit(): void {
    this.service.get().subscribe((data) => {
      this.Data = data;
    });
  }
}
